import { AppState } from '../reducers';

export const getTellUsAboutYouSections = () => {
  return [
    {
      id: 1,
      title:
        'Quali strumenti usi abitualmente per cucinare? Puoi selezionare più risposte:',
      options: [
        'Pentola a Pressione',
        'Pentole in alluminio antiaderente',
        'Pentole in acciaio inox',
        'Strumenti a manico amovibile (es: Ingenio)',
      ],
    },
    /*
    {
      id: 2,
      title:
        'Dove compri abitualmente i tuoi accessori da cucina? Puoi selezionare più risposte:',
      options: [
        'Negozi di casalinghi',
        'Negozi di elettronica',
        'Online',
        'Porta a Porta',
        'Supermercati',
        'Televendita',
        'Grandi magazzini casa',
      ],
    },
     */
  ];
};

export const getUser = (state: AppState) => {
  const { _persist, ...user } = state.user;

  return {
    ...user,
    isEligibleForCoupon:
      Boolean(user.data) &&
      user.data?.newsletterChecked &&
      getTellUsAboutYouSections().every((section) => {
        return section.options.some((option) =>
          user.data!.data.includes(option)
        );
      }),
  };
};
